<template>
  <div>
    <el-dialog :close-on-click-modal="false" title="新增" :visible.sync="visible" width="70%" :before-close="handleClose">
      <div>
        <el-form :model="form" :rules="rules" ref="roleForm" label-width="100px">
          <el-form-item label="帳號" prop="username">
            <el-input v-model="form.username" placeholder="請輸入"></el-input>
          </el-form-item>
          <el-form-item label="有效日期" prop="validAt">
            <el-date-picker v-model="form.validAt" type="datetime" placeholder="選擇日期時間"
              value-format="yyyy-MM-dd HH:mm:ss" default-time="23:59:59">
            </el-date-picker>
          </el-form-item>
          <el-form-item label="密碼" prop="password">
            <el-input v-model="form.password" type="password" placeholder="請輸入"></el-input>
          </el-form-item>
          <el-form-item label="設備MAC" prop="mac">
            <el-input v-model="form.mac" placeholder="請輸入"></el-input>
          </el-form-item>
          <el-form-item label="SSID" prop="ssid">
            <el-input v-model="form.ssid" placeholder="請輸入"></el-input>
          </el-form-item>

        </el-form>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button @click="handleClose">取 消</el-button>
        <el-button type="primary" @click="submit">确 定</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
  import wangEditorCos from "@/components/editor/wangEditorCos"
  import uploadPicture from "@/components/uploadPicture/uploadPicture"
  export default {
    components: {
      wangEditorCos,
      uploadPicture
    },
    props: {},
    data() {
      return {
        visible: false,
        showSlider: false,
        showImage: false,
        loading: true,
        form: {
          adminId:'',
          username: '',
          validAt: '',
          password: '',
        },
        rules: {
          title: [{
            required: true,
            message: "标题不能为空",
            trigger: "blur"
          }],
        },
      }
    },
    created() {},
    methods: {


      submit() {
        this.$refs.roleForm.validate((valid) => {
          if (valid) {
            this.$request({
              url: this.$api.adminuser.create,
              method: "post",
              data: this.form
            }).then((res) => {
              if (res.data.code == 1) {
                this.$message.success(res.data.msg)
                this.form = {
                  username: '',
                  validAt: '',
                  password: '',
                }
                this.$emit("ok");
                this.visible = false
              } else {
                this.$message.error(res.data.msg)
              }
            }).catch(() => {
              this.$message.error("请求失败");
            })
          } else {
            return false;
          }
        })

      },
      getDataD(val){
        console.log(val)
        this.form.adminId = val
      },

      handleClose() {
        this.visible = false;
      }
    }
  }
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/views/settings/admin/adminuser/createModal.vue